<template>
  <!-- Covers the viewer, which steps through the range while exporting. -->
  <div class="absolute inset-0 z-50 bg-gray-900 bg-opacity-75 flex items-center justify-center">
    <div class="w-72 p-4 rounded-md border border-gray-700 shadow-lg bg-gray-950 flex flex-col gap-4">
      <h2 class="text-text-primary text-sm font-medium">{{ $t('viewer.gif_dialog.export_gif') }}</h2>

      <p v-if="exporting" class="text-text-secondary text-sm">{{ progress }}</p>
      <template v-else>
        <div class="flex gap-2">
          <button
            v-for="seconds in LENGTHS"
            :key="seconds"
            :class="lengthS === seconds ? 'bg-primary-600' : 'bg-gray-800'"
            class="flex-1 px-3 py-2 rounded-md text-sm text-text-primary"
            @click="lengthS = seconds"
          >{{ seconds }} s</button>
        </div>
        <div class="flex gap-2">
          <button
            v-for="choice in PLACEMENTS"
            :key="choice.value"
            :class="placement === choice.value ? 'bg-primary-600' : 'bg-gray-800'"
            class="flex-1 px-3 py-2 rounded-md text-sm text-text-primary"
            @click="placement = choice.value"
          >{{ $t(choice.label) }}</button>
        </div>
        <p class="text-text-secondary text-sm">{{ rangeText({ lengthS, placement }) }}</p>
      </template>

      <div class="flex gap-2 justify-end">
        <button class="px-3 py-2 rounded-md text-sm bg-gray-800 text-text-primary" @click="$emit('cancel')">{{ $t('common.cancel') }}</button>
        <button
          v-if="!exporting"
          class="px-3 py-2 rounded-md text-sm bg-primary-600 text-text-primary"
          @click="$emit('export', { lengthS, placement })"
        >{{ $t('viewer.gif_dialog.export') }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { CAPTURE_CONFIG } from '../../utils/demoViewer/capture/config';

const LENGTHS = [3, 5, CAPTURE_CONFIG.gif.maxLengthS];
const PLACEMENTS = [
  { value: 'centred', label: 'viewer.gif_dialog.centred_on_now' },
  { value: 'starting', label: 'viewer.gif_dialog.starting_now' },
];

defineProps({
  exporting: Boolean,
  progress: String,
  rangeText: Function,
});

defineEmits(['export', 'cancel']);

const lengthS = ref(5);
const placement = ref('centred');
</script>
